import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import {
  AddContactGroupByEmailButton,
  AddContactGroupByEmailTrigger,
  ContactList,
  LocationList,
  VendorContactGroupList,
} from 'contacts/components';
import { ContactGroupType } from 'contacts/enums';
import { PageLayout, PageTitle, Tabs } from 'core/components';
import { SelectionCountProvider } from 'core/states';

export const VendorContactListPage = () => {
  const [searchParams] = useSearchParams();

  const { t } = useTranslation();

  const buttons = useMemo(() => {
    return [
      <AddContactGroupByEmailButton
        contactGroupType={ContactGroupType.VENDOR}
        key="addContactGroupByEmailButton"
        defaultOpen={searchParams.get('trigger') === AddContactGroupByEmailTrigger.ADD_VENDOR}
      />,
    ];
  }, [searchParams]);

  const tabs = useMemo(() => {
    return [
      {
        label: t('labelViewByLocations'),
        content: <LocationList contactGroupType={ContactGroupType.VENDOR} />,
      },
      {
        label: t('labelViewByCompanies'),
        content: <VendorContactGroupList />,
      },
      {
        label: t('labelViewByContacts'),
        content: <ContactList groupType={ContactGroupType.VENDOR} />,
      },
    ];
  }, [t]);

  return (
    <PageLayout title={t('titleVendorContacts')}>
      <SelectionCountProvider>
        <PageTitle title={t('titleVendors')} buttons={buttons} />

        <Tabs tabs={tabs} ariaLabel="vendorContactListTabs" />
      </SelectionCountProvider>
    </PageLayout>
  );
};
